import {
  FEATURE_FLAGS,
  BenefitsRedirectContainer,
  useTTVTracking,
} from '@highmark-web/highmark-common';
import { BenefitsRoutes, WalletRoutes } from 'components/lazy-routes.component';
import { useFeatureFlagQuery } from '@leagueplatform/user-profile-api';

export const AppBenefitsRoutes = () => {
  useTTVTracking();
  const { data: isBenefitsLandingMasonryV2Enabled } = useFeatureFlagQuery(
    FEATURE_FLAGS.ENABLE_BENEFITS_PAGE_2_0,
  );

  return isBenefitsLandingMasonryV2Enabled ? (
    <BenefitsRedirectContainer>
      <BenefitsRoutes />
    </BenefitsRedirectContainer>
  ) : (
    <WalletRoutes />
  );
};
